// extracted by mini-css-extract-plugin
module.exports = {"notRead":"NotificationBox_notRead__3ZLjh"};